/**
 * WordPress dependencies
 */
import { SelectControl, TextControl } from '@wordpress/components';
import { __ } from '@wordpress/i18n';
import { Fragment } from '@wordpress/element';
import { addFilter } from '@wordpress/hooks';

/**
 * External dependencies
 */

/**
 * Inner dependencies.
 */
import { updateBlockStyle } from '../inline-styles';
import Accordion from '../../../components/Accordion';
import AnimationDropDown from '../../../components/animation-dropdown';
import blockInfo from '../constants';
const { hookPrefix } = blockInfo;

addFilter(
	`gutenify-block-${ hookPrefix }-options-tab-advance`,
	`Gutenify/Block/${ hookPrefix }/InspectorControls/BasicControls/tabs/advance`,
	( content, props ) => {
		const { attributes, setAttributes } = props;
		const { blockAdvanceOptions } = attributes;
		const { entranceAnimation = '', entranceAnimationDuration = 'normal', entranceAnimationDelay = '' } = blockAdvanceOptions;
		return [
			...content,
			<Fragment key={ `gutenify-block-${ hookPrefix }-options-tab-content-basic` }>
				<Accordion tabs={ [
					{
						name: 'button',
						initialOpen: true,
						label: () => {
							return __( 'Motion Effect' );
						},
						cb: () => {
							return <>
								<AnimationDropDown label={ __( 'Entrance Animation' ) } onChange={ ( val ) => {
									const data = {
										blockAdvanceOptions: {
											...blockAdvanceOptions,
											entranceAnimation: val,
										},
									};
									setAttributes( data );
									updateBlockStyle( data, props );
								} } value={ entranceAnimation } />
								{ entranceAnimation && <>
									<SelectControl
										label={ __( 'Animation Duration' ) }
										onChange={ ( val ) => {
											const data = {
												blockAdvanceOptions: {
													...blockAdvanceOptions,
													entranceAnimationDuration: val,
												},
											};
											setAttributes( data );
											updateBlockStyle( data, props );
										} }
										value={ entranceAnimationDuration }
										options={ [
											{ value: 'slow', label: __( 'Slow' ) },
											{ value: 'normal', label: __( 'Normal' ) },
											{ value: 'fast', label: __( 'Fast' ) },
								    	] } />

									<TextControl label={ __( 'Animation Delay (ms)' ) } onChange={ ( val ) => {
										const data = {
											blockAdvanceOptions: {
												...blockAdvanceOptions,
												entranceAnimationDelay: val,
											},
										};
										setAttributes( data );
										updateBlockStyle( data, props );
									} } value={ entranceAnimationDelay } min={ 0 } />
								</> }
							</>;
						},
					},
				] } />
			</Fragment>,
		];
	}
);

